import { Component, computed, inject } from '@angular/core';
import { MobileFrameService, MobilePagePart } from '@eforall/mobile';


@Component({
	selector: 'activity-page',
	imports: [
		MobilePagePart,
	],
	templateUrl: './activity.page.html'
})
export class ActivityPage {
	private frame = inject(MobileFrameService);

	constructor() {
		this.frame.setUrlMetadata({
			url: '/activity',
			backUrl: '/',
			pageName: computed(() => `Activity`),
			headerText: computed(() => `Activity`),
		});
	}
}